<script setup lang="ts">
const { t } = useI18n();

const minHeightPx = 50 as const;
const items = computed(() =>
  [
    {
      icon: '<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.482 11.188a9.997 9.997 0 0 0-.211-1.019c-.62-2.514-2.098-5.293-4.909-5.372a3.45 3.45 0 0 0-2.019.595 3.767 3.767 0 0 0-3.259-1.919 3.752 3.752 0 0 0-3.259 1.92 3.45 3.45 0 0 0-2.019-.596c-3.958.211-5.278 5.504-5.278 8.15m18.46 14.543 1.32 3.97M10.33 27.504H24l5.107-9.568a6.18 6.18 0 0 0 .316-1.429 3.396 3.396 0 0 0-1.47-2.82 3.372 3.372 0 0 0-4.482.602 3.39 3.39 0 0 0-.677 3.11 3.39 3.39 0 0 0 .81 1.424l-.778 2.792a15.283 15.283 0 0 0-13.459 0l-.778-2.792a3.377 3.377 0 0 0 .814-3.037 3.378 3.378 0 0 0-2.037-2.392 3.357 3.357 0 0 0-4.205 1.532 3.382 3.382 0 0 0-.404 1.568c.048.488.154.967.316 1.43l5.093 9.58-1.319 3.97" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10"/></svg>',
      percentage: 40,
      name: t('homepage.market-development.items.furniture'),
    },
    {
      icon: '<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m20.698 8.38.787-3.907h3.773l4.707 4.72v3.774l-3.92.786A11.32 11.32 0 0 1 10.87 28.74a11.027 11.027 0 0 1-5.266-5.333A11.32 11.32 0 0 1 20.698 8.38Zm0 0a11.18 11.18 0 0 1 3.133 2.213c.307.309.596.634.867.974M20.605 26.66a9.04 9.04 0 0 1-6.293 2.667 7.499 7.499 0 0 1-.774 0 9.333 9.333 0 0 1-5.707-2.707 7.852 7.852 0 0 1-.706-.787 9.333 9.333 0 0 1-2.013-5.56v-.106a9.067 9.067 0 0 1 13.92-7.627 8.612 8.612 0 0 1 2.853 2.867 9.054 9.054 0 0 1-1.28 11.253Z" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10"/></svg>',
      percentage: 37,
      name: t('homepage.market-development.items.jewelry'),
    },
    {
      icon: '<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.357 26.14H3.03l1.48-9.333h10.368l1.479 9.333Zm0 0 1.493-9.333h10.368l1.479 9.333h-13.34Zm4.904-18.667H11.44l-1.399 9.334h12.634L21.26 7.473Z" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10"/></svg>',
      percentage: 71,
      name: t('homepage.market-development.items.gold'),
    },
    {
      icon: '<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.216 27.624a14.465 14.465 0 0 1-1.169-2.85 26.265 26.265 0 0 1-1.169-7.987 26.115 26.115 0 0 1 1.169-7.988c1.028-3.249 2.688-5.326 4.546-5.326 3.132 0 5.68 5.951 5.68 13.314 0 7.362-2.606 13.353-5.68 13.353m-4.604 0c-1.859 0-3.506-2.104-4.547-5.325a26.266 26.266 0 0 1-1.168-7.988c-.025-2.72.37-5.424 1.168-7.988 1.029-3.249 2.688-5.326 4.546-5.326m4.547-.013h-4.546m4.546 26.627h-4.546" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10"/></svg>',
      percentage: 56,
      name: t('homepage.market-development.items.coins'),
    },
    {
      icon: '<svg width="33" height="33" viewBox="0 0 56.69 56.69"><path stroke="#fff" stroke-width="1.5" stroke-miterlimit="10" d="M37.33 49.21H19.37a9.905 9.905 0 0 1-9.82-11.19l1.84-14.09h33.29v1.42H12.64l-1.68 12.86c-.32 2.42.43 4.86 2.04 6.7s3.93 2.89 6.38 2.89h17.96c2.44 0 4.77-1.05 6.38-2.89s2.35-4.28 2.04-6.7l1.41-.18a9.905 9.905 0 0 1-9.82 11.19Z"/><path stroke="#fff" stroke-width="1.5" stroke-miterlimit="10" d="m30.02 39-.16-1.41c6.57-.76 11.52-6.33 11.52-12.95h1.42c0 7.34-5.49 13.51-12.77 14.36Zm-3.35 0c-6.22-.72-11.37-5.52-12.53-11.68l1.39-.26c1.04 5.56 5.69 9.89 11.3 10.54l-.16 1.41Z"/><path stroke="#fff" stroke-width="1.5" stroke-miterlimit="10" d="M28.98 41.38h-1.27c-.92 0-1.66-.75-1.66-1.66v-2.68c0-.92.75-1.66 1.66-1.66h1.27c.92 0 1.66.75 1.66 1.66v2.68c0 .92-.75 1.66-1.66 1.66Zm-1.27-4.58c-.14 0-.25.11-.25.25v2.68c0 .14.11.25.25.25h1.27c.14 0 .25-.11.25-.25v-2.68c0-.14-.11-.25-.25-.25h-1.27Zm11.56-14.44h-1.42v-3.95c0-5.24-4.26-9.51-9.5-9.51-2.54 0-4.93.99-6.73 2.78-1.8 1.79-2.78 4.18-2.78 6.73v1.61h-1.42v-1.61c0-2.92 1.14-5.67 3.2-7.73a10.87 10.87 0 0 1 7.73-3.2c6.02 0 10.92 4.9 10.92 10.93v3.95Z"/><path stroke="#fff" stroke-width="1.5" stroke-miterlimit="10" d="M40.9 25.35h-4.67v-2.33c0-.76.62-1.38 1.38-1.38h1.91c.76 0 1.38.62 1.38 1.38v2.33Zm-3.27-1.42h1.85v-.91l-1.87.04.02.87Zm-17.16 1.42H15.8v-2.33c0-.76.62-1.38 1.38-1.38h1.91c.76 0 1.38.62 1.38 1.38v2.33Zm-3.27-1.42h1.85v-.91l-1.87.04.02.87Zm27.078 3.146 1.408-.184 1.454 11.136-1.408.184z"/></svg>',
      percentage: 67,
      name: t('homepage.market-development.items.handbags'),
    },
    {
      icon: '<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.242 28.807H4.91V3.473m19 6.334h5.067m0 0v5.066m0-5.066-6.334 6.333-5.18-2.42-7.486 7.487" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10"/></svg>',
      percentage: 91,
      name: t('homepage.market-development.items.stocks'),
    },
    {
      icon: '<svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m17.418 15.374-4.938-3.527-8.466 4.233M28 20.313l-5.644-4.233-18.342 8.466M4 4.806h24v24H4v-24Z" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10"/></svg>',
      percentage: 105,
      name: t('homepage.market-development.items.art'),
    },
    {
      icon: '<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.849 2.807v6.892l2 2.298m16.68-6.718h-16m13.986 6.718 2-2.298V2.807m-12 18.326v-10.48m5.347 0v10.48m1.32-10.144a7.827 7.827 0 0 0-1.333-.55 8.78 8.78 0 0 0-2.667-.444 8.535 8.535 0 0 0-4.12 1.048m-4.147 2.794H5.69a3.482 3.482 0 0 0-2.485 1.04 3.535 3.535 0 0 0-1.022 2.507v2.15m28 0v-2.297a3.55 3.55 0 0 0-1.027-2.499 3.493 3.493 0 0 0-2.48-1.035H24.45M3.515 26.104h4v4.703h-4v-4.703Zm21.334 0h4v4.703h-4v-4.703Zm-22.667-4.03h28v4.03h-28v-4.03Zm11-8.8c0 .53-.157 1.05-.45 1.492a2.67 2.67 0 0 1-1.196.99 2.648 2.648 0 0 1-2.906-.583 2.706 2.706 0 0 1-.578-2.928c.201-.491.543-.911.982-1.206a2.653 2.653 0 0 1 3.838.972c.204.388.31.822.31 1.262Zm6-.149c0 .532.156 1.051.45 1.493a2.648 2.648 0 0 0 4.103.407 2.707 2.707 0 0 0 .578-2.928 2.683 2.683 0 0 0-.983-1.206 2.652 2.652 0 0 0-3.367.334 2.698 2.698 0 0 0-.781 1.9Z" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10"/></svg>',
      percentage: 82,
      name: t('homepage.market-development.items.antique-cars'),
    },
    {
      icon: '<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.95 30.14v-4.546a12.037 12.037 0 0 0 2.793-3.994A12.091 12.091 0 0 0 24.95 8.045V3.473H11.56m-3.032 0v4.56a12.012 12.012 0 0 0-2.81 3.995 12.067 12.067 0 0 0 0 9.583 12.012 12.012 0 0 0 2.81 3.996v4.533h13.895m-2.286-8.546-3.41-4.775v-6.171m8.854 6.171c0 4.917-3.964 8.902-8.855 8.902-4.89 0-8.855-3.985-8.855-8.902 0-4.916 3.965-8.901 8.855-8.901 4.89 0 8.855 3.985 8.855 8.901Z" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10"/></svg>',
      percentage: 138,
      name: t('homepage.market-development.items.watches'),
    },
    {
      icon: '<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m13.628 11.9 6.267 6.267L12.6 25.46l-4.186-4.173m16.693-14.6 2.08 2.093m-3.267 3.28 6.4-6.4-2.093-2.093-6.4 6.4a5.88 5.88 0 0 0-7.16.893l-.573.52-.52.52L3.2 22.327l8.347 8.333 10.427-10.413.52-.534.52-.52a5.893 5.893 0 0 0 .906-7.133Z" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10"/></svg>',
      percentage: 146,
      name: t('homepage.market-development.items.wine'),
    },
    {
      icon: '<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m14.116 13.82-1.026-2.76a3.6 3.6 0 0 1 0-2.48l1.026-2.76h3.694l1.026 2.747a3.524 3.524 0 0 1 0 2.506L17.81 13.82m6.16 13.987h-16m0-9.334h13.333m2 13.334H8.636l-1.333-16 6.667-2.667h4l6.666 2.667-1.333 16ZM12.623 3.14h6.68v2.667h-6.68V3.14Z" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10"/></svg>',
      percentage: 280,
      name: t('homepage.market-development.items.whiskey'),
    },
  ].sort((a, b) => a.percentage - b.percentage),
);
const baseFraction = items.value[0].percentage;

function fraction(percentage: number) {
  const height = (percentage / baseFraction) * minHeightPx;
  const newHeight = height * 0.5;
  if (newHeight > 300) {
    return `${height * 0.35}px`;
  }

  return `${newHeight}px`;
}
</script>

<template>
  <div class="market-development-wrapper">
    <div class="market-development">
      <div v-for="item in items" :key="item.name" class="market-development__item">
        <span aria-hidden="true" class="market-development__icon" v-html="item.icon" />
        <div
          class="market-development__column"
          :style="{ '--dimension': fraction(item.percentage) }"
        >
          {{ $n(item.percentage / 100, 'percent') }}
        </div>
        <span class="market-development__name">{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.market-development-wrapper {
  position: relative;
  width: calc(100vw - 5vmax);

  overflow: hidden;

  @media (min-width: 992px) {
    width: unset;
    height: 20rem;

    overflow: unset;
  }
}

.market-development {
  display: flex;
  flex-direction: column-reverse;
  gap: 1.25rem;

  @media (min-width: 992px) {
    position: absolute;
    bottom: 0;
    z-index: -1;

    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    gap: 0.625rem;

    width: 100%;
  }

  .market-development__item {
    display: grid;
    grid-template-areas:
      'icon name'
      'column column';
    align-items: center;
    grid-template-columns: 1.5rem 1fr;
    gap: 0.625rem;

    @media (min-width: 992px) {
      grid-template-areas:
        'icon'
        'column'
        'name';
      align-items: initial;
      grid-template-columns: initial;
      flex: 1;

      text-align: center;
    }
  }

  .market-development__icon {
    grid-area: icon;
    justify-self: center;

    width: 1.5rem;
    height: 1.5rem;

    @media (min-width: 992px) {
      width: 2rem;
      height: 2rem;
    }

    :deep(svg) {
      width: inherit;
      height: inherit;
    }
  }

  .market-development__name {
    grid-area: name;
  }

  .market-development__column {
    grid-area: column;

    display: flex;
    align-items: flex-end;
    justify-content: flex-start;

    padding: 0.625rem 0.3125rem;

    background-color: var(--gray-bright);
    border-radius: 0.375rem;

    font-size: clamp(1rem, 0.38vw + 0.91rem, 1.125rem);
    font-weight: 700;
    color: var(--black);

    @media (max-width: 991.98px) {
      min-width: 3.125rem;
      width: var(--dimension);
    }

    @media (min-width: 992px) {
      justify-content: center;

      min-height: 3.125rem;
      height: var(--dimension);
    }
  }
}
</style>
